import axios from "axios";

export const pkiAxios = axios.create();

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const appRetirementService = {
    searchApplications: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}application-retirement/searchApplications`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
    getApplicationDetails: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}application-retirement/getApplicationDetails`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
    validateCertificate: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}application-retirement/validate-certificate`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
    certificateVersions: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}application-retirement/certificate-versions`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
    submitRetirementRequest: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}application-retirement/submitRetirementRequest`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    }
};

export default appRetirementService;